const { fetchJSON } = window.BAO.Utils

export class StoreSelector extends window.BAO.CustomElement() {
  _apiKey = '2f2905b7b278464cad3dee0917d6b37f'

  connectedCallback () {
    if (document.location.host.includes('patchworks')) return

    super.connectedCallback()
    this.handleCountryLogic = this.handleCountryLogic.bind(this)

    window.addEventListener('load', () => {
      const currentCookieValue = this.getCookie('OptanonConsent')

      if (window.OnetrustActiveGroups === ',C0001,') {
        window.OneTrust.OnConsentChanged(() => {
          this.dispatchCookieChangeEvent(currentCookieValue)
        })
      } else {
        this.handleCountryLogic()
      }
    })

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    // Watches for custom event, this occurs after cookies have
    // been changed which then invokes the location selector.
    document.addEventListener('cookieChange', () => {
      this.handleCountryLogic()
    })

    this.setupListeners()
  }

  handleCountryLogic () {
    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcherModal(countryCode)
      this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcherModal(countryCode)
      this.updateShippingLabel(countryCode)
    } else {
      fetchJSON(
        `https://api.ipgeolocation.io/ipgeo?apiKey=${this._apiKey}&fields=country_code2`,
        {
          method: 'GET',
        },
      ).then(res => {
        const countryCode = res.country_code2

        this.setupCountrySwitcherModal(countryCode)
        this.updateShippingLabel(countryCode)
      })
    }
  }

  forceRedirect () {
    fetchJSON(
      `https://api.ipgeolocation.io/ipgeo?apiKey=${this._apiKey}&fields=country_code2`,
      {
        method: 'GET',
      },
    ).then(res => {
      const userCountry = res.country_code2

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter(item => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.sites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}&currency=${
        this.countries[userCountry].currency
      }`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionClick = this.onOptionClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)

    if (this.els?.options.exists) {
      this.els.options.elements.forEach(optionEl => {
        this.listeners.add(optionEl, 'change', this.onOptionClick)
      })
    }

    if (this.els?.confirm.exists) {
      this.els.confirm.elements.forEach(confirmEl => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEL => {
        this.listeners.add(closeEL, 'click', this.onCloseClick)
      })
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    }

    /* Added due to trigger in mobile menu being rendered after page load */
    document.addEventListener('click', e => {
      if (e?.target?.dataset?.storeSelectorExternalEl === 'trigger') {
        this.onTriggerClick()
      }
    })
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  onTriggerClick () {
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
    document.body.classList.add('util-HideChat')
  }

  onOptionClick (e) {
    const selectedOptionValue = e.currentTarget.value
    const selectedOptionCode =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.code
    const selectedOptionCurrency =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.currency

    this.els.flag.element.src = `https://cdn.shopify.com/s/files/1/0563/8314/3997/files/flag-${selectedOptionCode}.svg`

    this.els.confirm.elements.forEach(confirmEl => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
      confirmEl.dataset.currency = selectedOptionCurrency
    })
  }

  getCookie (name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts
        .pop()
        .split(';')
        .shift()
    }
  }

  dispatchCookieChangeEvent (newValue) {
    const event = new CustomEvent('cookieChange', {
      detail: {
        cookieName: 'OptanonConsent',
        newValue,
      },
    })

    // Dispatch the event
    document.dispatchEvent(event)
  }

  onConfirmClick (event) {
    event.preventDefault()

    let windowPathname = window.location.pathname

    const subdomainFolder = windowPathname.split('/').filter(item => {
      return item.indexOf('en-') > -1
    })

    if (subdomainFolder) {
      windowPathname = windowPathname
        .replace(subdomainFolder, '')
        .replace('//', '/')
    }

    if (
      this.countries[event.currentTarget.dataset.code].site ===
      this.dataset.store
    ) {
      window.localStorage.setItem(
        this.userLocationName,
        event.currentTarget.dataset.code,
      )

      this.els['localisation-select'].element.value =
        event.currentTarget.dataset.code
      this.els['localisation-select'].element.dispatchEvent(new Event('change'))
    } else if (event.currentTarget.hasAttribute('data-url')) {
      window.location.href = `${event.currentTarget.dataset.url}${windowPathname}?country=${event.currentTarget.dataset.code}&currency=${event.currentTarget.dataset.currency}`
    }

    window.dataLayer.push({
      page_type: 'store_switcher',
      event: 'store_switcher',
      current_store: `${this.dataset.store}`,
      chosen_country: `${event.currentTarget.dataset.code}`,
    })
  }

  onCloseClick (event) {
    event.preventDefault()

    if (this.noLocationStored) {
      if (
        this.countries[event.currentTarget.dataset.code].site ===
        this.dataset.store
      ) {
        window.localStorage.setItem(this.userLocationName, this.dataset.store)
      }
    }

    this.setAttribute('aria-hidden', 'true')

    if (document.body.classList.contains('util-DrawersOpen')) return
    document.body.classList.remove('util-SiteOverflowed')
    document.body.classList.remove('util-HideChat')
  }

  updateShippingLabel (countryCode) {
    if (this.noLocationStored) return

    const upperCountryCode = countryCode.toUpperCase()

    if (this.externalEls?.flag.exists) {
      this.externalEls.flag.elements.forEach(flagExternalEl => {
        flagExternalEl.src = `https://cdn.shopify.com/s/files/1/0563/8314/3997/files/flag-${upperCountryCode}.svg`
      })
    }

    /* Added due to trigger in mobile menu being rendered after page load */
    window.setTimeout(() => {
      document
        .querySelectorAll('[data-store-selector-external-el="flag"]')
        .forEach(el => {
          el.src = `https://cdn.shopify.com/s/files/1/0563/8314/3997/files/flag-${upperCountryCode}.svg`
        })
    }, 1000)

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name
      const currency = this.countries[upperCountryCode].currency

      if (this.externalEls?.label.exists) {
        this.externalEls.label.elements.forEach(labelExternalEl => {
          labelExternalEl.innerHTML = `${name} / ${currency}`
          labelExternalEl.dataset.content = `${name} / ${currency}`
        })
      }

      /* Added due to trigger in mobile menu being rendered after page load */
      window.setTimeout(() => {
        document
          .querySelectorAll('[data-store-selector-external-el="label"]')
          .forEach(el => {
            el.innerHTML = `${name} / ${currency}`
            el.dataset.content = `${name} / ${currency}`
          })
      }, 1000)
    }

    if (this.externalEls?.trigger.exists) {
      this.externalEls.trigger.elements.forEach(triggerExternalEl => {
        triggerExternalEl.style.opacity = 1
      })
    }
  }

  setupCountrySwitcherModal (countryCode) {
    this.createOptionsList(countryCode)
    this.setDefaultConfirmButtonURL()

    this.els.flag.element.src = `https://cdn.shopify.com/s/files/1/0563/8314/3997/files/flag-${countryCode}.svg`
    window.setTimeout(() => {
      this.els.flag.element.src = `https://cdn.shopify.com/s/files/1/0563/8314/3997/files/flag-${countryCode}.svg`
    }, 500)

    if (
      this.countries[countryCode].site === this.dataset.store &&
      this.dataset.store === 'UK'
    ) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    if (!this.noLocationStored) {
      this.els.close.element.setAttribute('aria-hidden', false)

      return
    }

    if (this.countryParam !== null) return

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
    document.body.classList.add('util-HideChat')
  }

  createOptionsList (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.els.options.element.innerHTML += this.createOptionElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )
    })
  }

  createOptionElement (code, site, isCurrentSite, country, currency) {
    return `<option
      data-code="${code}"
      data-currency="${currency}"
      value="${site}"
      ${isCurrentSite ? 'selected' : ''}
    >
      ${country} / ${currency}
    </option>`
  }

  setDefaultConfirmButtonURL () {
    const selectedOptionValue = this.els.options.element.value
    const selectedOptionCode = this.els.options.element.options[
      this.els.options.element.selectedIndex
    ].dataset.code
    const selectedOptionCurrency = this.els.options.element.options[
      this.els.options.element.selectedIndex
    ].dataset.currency

    this.els.confirm.elements.forEach(confirmEl => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
      confirmEl.dataset.currency = selectedOptionCurrency
    })
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !Shopify.designMode)
    )
  }

  get userLocationName () {
    return `BAO-localization`
  }

  get sites () {
    return {
      UK: {
        url: 'https://shop.mercedesamgf1.com',
        currency: '&currency=GBP',
      },
      US: {
        url: 'https://shop-us.mercedesamgf1.com',
        currency: '&currency=USD',
      },
      INT: {
        url: 'https://shop-int.mercedesamgf1.com',
        currency: '&currency=EUR',
      },
    }
  }

  get excludedCountries () {
    return window.theme.excludedCountries
  }

  get countries () {
    const countriesObject = Object.fromEntries(
      Object.entries(window.theme.countries).filter(
        ([key]) => !this.excludedCountries.includes(key),
      ),
    )

    return countriesObject
  }
}

if (!customElements.get('store-selector')) {
  customElements.define('store-selector', StoreSelector)
}
